import {FieldPath, useController, useFormContext} from 'react-hook-form';

import {AddressFormItemType, AddressFormType} from 'desktop/types/addressType';

/**
 * Register delivery field
 */
export const useDeliveryFieldRegister = (
    fieldKey: FieldPath<AddressFormItemType>,
    target: 'shippingAddress' | 'billingAddress',
) => {
    const {control} = useFormContext<AddressFormType>();

    return useController<AddressFormType>({
        control,
        name: `${target}.${fieldKey}`,
    });
};
